import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import Landing from './pages/Landing';
import About from './pages/About';
import Contact from './pages/Contact';
import BookAMeeting from './pages/BookAMeeting';
import Blog from './pages/Blog';
import PostDetail from './pages/PostDetail';
import SignIn from './pages/SignIn';
import Dashboard from './pages/Dashboard';
import TermsOfUse from './pages/TermsOfUse';
import PrivacyPolicy from './pages/PrivacyPolicy';

const AppRouter = () => {
  const { currentUser } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/about" element={<About />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/book-a-meeting" element={<BookAMeeting />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:postId" element={<PostDetail />} />
      <Route path="/signin" element={<SignIn />} />
      <Route path="/terms-of-use" element={<TermsOfUse />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      
      <Route 
        path="/dashboard" 
        element={currentUser ? <Dashboard /> : <Navigate to="/signin" />} 
      />
    </Routes>
  );
};

export default AppRouter;
